import SCHOOLS_BY_NAME_AUT_RESPONSE from './SCHOOLS_BY_NAME/SCHOOLS_BY_NAME_AUT_RESPONSE';
import SCHOOLS_BY_NAME_DB_RESPONSE from './SCHOOLS_BY_NAME/SCHOOLS_BY_NAME_DB_RESPONSE';
import SCHOOLS_BY_NAME_DD_RESPONSE from './SCHOOLS_BY_NAME/SCHOOLS_BY_NAME_DD_RESPONSE';
import SCHOOLS_BY_NAME_EMN_RESPONSE from './SCHOOLS_BY_NAME/SCHOOLS_BY_NAME_EMN_RESPONSE';
import SCHOOLS_BY_NAME_HI_RESPONSE from './SCHOOLS_BY_NAME/SCHOOLS_BY_NAME_HI_RESPONSE';
import SCHOOLS_BY_NAME_MR_RESPONSE from './SCHOOLS_BY_NAME/SCHOOLS_BY_NAME_MR_RESPONSE';
import SCHOOLS_BY_NAME_MD_RESPONSE from './SCHOOLS_BY_NAME/SCHOOLS_BY_NAME_MD_RESPONSE';
import SCHOOLS_BY_NAME_OI_RESPONSE from './SCHOOLS_BY_NAME/SCHOOLS_BY_NAME_OI_RESPONSE';
import SCHOOLS_BY_NAME_OHI_RESPONSE from './SCHOOLS_BY_NAME/SCHOOLS_BY_NAME_OHI_RESPONSE';
import SCHOOLS_BY_NAME_SLD_RESPONSE from './SCHOOLS_BY_NAME/SCHOOLS_BY_NAME_SLD_RESPONSE';
import SCHOOLS_BY_NAME_SLI_RESPONSE from './SCHOOLS_BY_NAME/SCHOOLS_BY_NAME_SLI_RESPONSE';
import SCHOOLS_BY_NAME_TBI_RESPONSE from './SCHOOLS_BY_NAME/SCHOOLS_BY_NAME_TBI_RESPONSE';
import SCHOOLS_BY_NAME_VI_RESPONSE from './SCHOOLS_BY_NAME/SCHOOLS_BY_NAME_VI_RESPONSE';
import SCHOOLS_BY_NAME_TOTAL_RESPONSE from './SCHOOLS_BY_NAME/SCHOOLS_BY_NAME_TOTAL_RESPONSE';

const ALL_SCHOOLS_BY_NAME_RESPONSES = {
  AUT: SCHOOLS_BY_NAME_AUT_RESPONSE,
  DB: SCHOOLS_BY_NAME_DB_RESPONSE,
  DD: SCHOOLS_BY_NAME_DD_RESPONSE,
  EMN: SCHOOLS_BY_NAME_EMN_RESPONSE,
  HI: SCHOOLS_BY_NAME_HI_RESPONSE,
  MD: SCHOOLS_BY_NAME_MD_RESPONSE,
  MR: SCHOOLS_BY_NAME_MR_RESPONSE,
  OHI: SCHOOLS_BY_NAME_OHI_RESPONSE,
  OI: SCHOOLS_BY_NAME_OI_RESPONSE,
  SLD: SCHOOLS_BY_NAME_SLD_RESPONSE,
  SLI: SCHOOLS_BY_NAME_SLI_RESPONSE,
  TBI: SCHOOLS_BY_NAME_TBI_RESPONSE,
  VI: SCHOOLS_BY_NAME_VI_RESPONSE,
  TOTAL: SCHOOLS_BY_NAME_TOTAL_RESPONSE,
};

export default ALL_SCHOOLS_BY_NAME_RESPONSES;
